const es = {
  a11yVideoLabelText: "Video mostrando la verificación de la vivacidad facial",
  cameraMinSpecificationsHeadingText: "Especificaciones mínimas de la cámara",
  cameraMinSpecificationsMessageText:
    "Por favor, asegúrese de que su cámara cumpla con las especificaciones mínimas requeridas para la verificación de vivacidad.",
  cameraNotFoundHeadingText: "Cámara no encontrada",
  cameraNotFoundMessageText:
    "No pudimos detectar una cámara. Por favor, asegúrese de que su cámara esté conectada y vuelva a intentarlo.",
  cancelLivenessCheckText: "Cancelar verificación de vivacidad",
  clientHeaderText: "Mensaje del cliente",
  clientMessageText:
    "Por favor, siga las instrucciones en la pantalla para completar la verificación de vivacidad facial.",
  connectionTimeoutHeaderText: "Tiempo de conexión agotado",
  connectionTimeoutMessageText:
    "La conexión se agotó. Por favor, revise su conexión a Internet y vuelva a intentarlo.",
  errorLabelText: "Error",
  faceDistanceHeaderText: "Distancia facial",
  faceDistanceMessageText:
    "Por favor, asegúrese de que su rostro esté a la distancia correcta de la cámara.",
  goodFitAltText: "El rostro está bien alineado",
  goodFitCaptionText:
    "Su rostro está bien alineado. Por favor, manténgase quieto.",
  hintCanNotIdentifyText:
    "No se puede identificar el rostro. Por favor, inténtelo de nuevo.",
  hintCenterFaceInstructionText: "Centre su rostro en el marco.",
  hintCenterFaceText: "Centre su rostro",
  hintCheckCompleteText: "Verificación completa",
  hintConnectingText: "Conectando...",
  hintFaceDetectedText: "Rostro detectado",
  hintFaceOffCenterText: "Su rostro está descentrado. Por favor, ajuste.",
  hintHoldFaceForFreshnessText:
    "Mantenga su rostro quieto para la verificación.",
  hintIlluminationNormalText: "La iluminación es buena",
  hintIlluminationTooBrightText: "La iluminación es demasiado brillante",
  hintIlluminationTooDarkText: "La iluminación es demasiado oscura",
  hintMatchIndicatorText: "Comparando indicadores faciales...",
  hintMoveFaceFrontOfCameraText: "Mueva su rostro frente a la cámara",
  hintTooCloseText: "Está demasiado cerca de la cámara",
  hintTooFarText: "Está demasiado lejos de la cámara",
  hintTooManyFacesText:
    "Se detectaron demasiados rostros. Solo un rostro debe estar en el marco.",
  hintVerifyingText: "Verificando...",
  landscapeHeaderText: "Modo paisaje detectado",
  landscapeMessageText:
    "Por favor, cambie al modo retrato para la verificación de vivacidad.",
  multipleFacesHeaderText: "Se detectaron múltiples rostros",
  multipleFacesMessageText:
    "Solo un rostro debe estar en el marco. Por favor, ajuste y vuelva a intentarlo.",
  photosensitivityWarningBodyText:
    "Esta verificación implica una serie de estímulos visuales. Si tiene problemas de fotosensibilidad, proceda con precaución.",
  photosensitivityWarningHeadingText: "Advertencia de fotosensibilidad",
  photosensitivityWarningInfoText:
    "Puede detener la verificación en cualquier momento si siente incomodidad.",
  photosensitivityWarningLabelText: "Entiendo los riesgos",
  portraitMessageText: "Por favor, mantenga su dispositivo en modo retrato.",
  recordingIndicatorText: "Grabación en progreso",
  retryCameraPermissionsText: "Reintentar permisos de cámara",
  serverHeaderText: "Problema del servidor",
  serverMessageText:
    "Hubo un problema al conectar con el servidor. Por favor, inténtelo de nuevo más tarde.",
  startScreenBeginCheckText: "Iniciar verificación de vivacidad",
  timeoutHeaderText: "Tiempo agotado",
  timeoutMessageText: "El proceso se agotó. Por favor, inténtelo de nuevo.",
  tooFarAltText: "El rostro está demasiado lejos de la cámara",
  tooFarCaptionText: "Por favor, acérquese a la cámara.",
  tryAgainText: "Intentar de nuevo",
  waitingCameraPermissionText: "Esperando permiso de la cámara...",
};

export default es;
